import { useTranslation } from "@repo/shared/i18n";

/*
  Preferred foot reaches the screen as "Right" from players and "right" from
  the evolved-player mapper, so the lookup is case-insensitive. The value
  stays English as identity (filters, compare); only display goes through
  here. Unknown strings fall through untouched.
*/
const FOOT_LABEL_KEYS = {
  left: "filters.preferredFoot.left",
  right: "filters.preferredFoot.right",
} as const;

export const useFootLabel = () => {
  const { t } = useTranslation("players");
  return (foot: string | undefined) => {
    const key =
      FOOT_LABEL_KEYS[
        (foot ?? "").toLowerCase() as keyof typeof FOOT_LABEL_KEYS
      ];
    return key ? t(key) : foot;
  };
};
